// extracted by mini-css-extract-plugin
export default {"wrapper":"LangSwitcher_wrapper__ep0C5","switcher":"LangSwitcher_switcher__drQ3w","active":"LangSwitcher_active__T-vWb"};